/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { Task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import { ApiError } from 'cio/services/api';

interface SendTestSignature {
  Element: HTMLFormElement;
  Args: {
    platform: 'android' | 'ios';
    provider: string;
    errors?: Record<string, any>[];
    useCredentials: boolean;
    sendToSandbox?: boolean;
    getCredentials: Task<unknown, unknown[]>;
    onErrors: (errors: ApiError[]) => unknown;
  };
}

export default class SendTest extends Component<SendTestSignature> {
  /* eslint-disable-next-line ember/no-tracked-properties-from-args */
  @tracked platform = this.args.platform;
  /* eslint-disable-next-line ember/no-tracked-properties-from-args */
  @tracked provider = this.args.provider;

  readonly preview = {
    body: "If you're reading this, it means your integration with Customer.io is working!",
    title: 'TEST',
  };

  get useCredentials() {
    return this.args.useCredentials ?? false;
  }

  get sendToSandbox() {
    return this.args.sendToSandbox ?? false;
  }

  @action
  onPlatformChange(platform: 'android' | 'ios') {
    this.platform = platform;
  }
}
